import React from 'react';
import { connect } from 'react-redux';
import { Routes } from '@common-packages/routes-definitions';

import withContextWrapper from '../shared/displayComponents/contextWrapper/withContextWrapperHoc.container';
import AuthorizedCustomRoute from '../shared/authorization/authorizedCustomRoute';
import GlobalContextPage from '../shared/displayComponents/globalContextPage.component';
import { isFetchingGlobalContextSelector } from '../shared/store/selectors';

import MemberInformationalData from './memberInformationalData.container';

const MemberInformationalDataWithContext = withContextWrapper()(MemberInformationalData);

const MemberInformationalDataPage = connect(state => ({
  isFetchingContext: isFetchingGlobalContextSelector(state),
}))(GlobalContextPage);

const MemberInformationalDataRoutes = () => (
  <AuthorizedCustomRoute
    exact
    path={Routes.memberInformationalData.MAIN}
    wrapper={MemberInformationalDataPage}
    component={MemberInformationalDataWithContext}
    hideGlobalContext
    disableBreadcrumbs
  />
);

export default MemberInformationalDataRoutes;
